import type { CustomerData, Plant, SelectionMap, Site } from './addUserTypes';

function plantsMatchingSearch(plants: Plant[], searchLower: string): Plant[] {
    const matching: Plant[] = [];
    for (const plant of plants) {
        if (plant.plantName.toLowerCase().includes(searchLower)) {
            matching.push(plant);
        }
    }
    return matching;
}

function sitesMatchingSearch(sites: Site[], searchLower: string): Site[] {
    const matchingSites: Site[] = [];
    for (const site of sites) {
        const siteMatches = site.siteName.toLowerCase().includes(searchLower);
        const matchingPlants = plantsMatchingSearch(site.plants, searchLower);
        if (!siteMatches && matchingPlants.length === 0) {
            continue;
        }
        matchingSites.push({
            ...site,
            plants: siteMatches ? site.plants : matchingPlants,
        });
    }
    return matchingSites;
}

export function filterCustomersBySearch(
    customersAndSites: CustomerData[],
    searchValue: string
): CustomerData[] {
    if (!searchValue.trim()) {
        return customersAndSites;
    }

    const searchLower = searchValue.toLowerCase();
    const filtered: CustomerData[] = [];

    for (const customer of customersAndSites) {
        const customerMatches = customer.customerName.toLowerCase().includes(searchLower);
        const matchingSites = sitesMatchingSearch(customer.sitesAndPlants, searchLower);
        if (!customerMatches && matchingSites.length === 0) {
            continue;
        }
        filtered.push({
            ...customer,
            sitesAndPlants: customerMatches ? customer.sitesAndPlants : matchingSites,
        });
    }

    return filtered;
}

export function buildExpandedItemsForCustomers(
    filtered: CustomerData[],
    currentExpanded: SelectionMap
): SelectionMap {
    const newExpandedItems = { ...currentExpanded };
    for (const customer of filtered) {
        newExpandedItems[customer.customerId] = true;
        for (const site of customer.sitesAndPlants) {
            newExpandedItems[site.siteId] = true;
        }
    }
    return newExpandedItems;
}
